import { InterviewService } from "../../../services/InterviewService";
import IconDelete from "../../../layout/others/icon_delete.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ModalContainer from "../../../containers/Modal/ModalContainer";
export default function DeleteDocument({
  interviewId,
  documentId,
  deleteCallBack
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  function deleteDocument(event) {
    event.stopPropagation();
    setIsOpen(true);
  }
  function submitDelete(event) {
    event.stopPropagation();
    InterviewService.deleteDocument(interviewId, documentId).then(() => {
      deleteCallBack();
      setIsOpen(false);
    });
  }

  function closeModal(event) {
    event.stopPropagation();
    setIsOpen(false);
  }
  return (
    <>
      {" "}
      <button
        type="button"
        onClick={deleteDocument}
        className="action-button"
        title={t("Delete")}
      >
        <img src={IconDelete} alt="download" width="18px" height="22px" marginTop="-4px" />
      </button>
      <ModalContainer
        modalTitle={t("Delete")}
        isOpen={isOpen}
        submitButtonAction={submitDelete}
        submitButtonTitle={t("Confirm")}
        submitButtonType="button"
        cancelButtonAction={closeModal}
        cancelButtonTitle={t("Cancel")}
        closeModal={closeModal}
        crossmarkAction={closeModal}
      >
        {t("Do you want to eliminate this document?")}
      </ModalContainer>
    </>
  );
}
